import { FC, isValidElement, ReactNode } from 'react';
import classNames from 'classnames';
import { isString } from '~/utils';

interface PrefixedLabelProps {
    title: string;
    description?: ReactNode;
    size?: 'large' | 'normal';
    className?: string;
}

const PrefixedLabel: FC<PrefixedLabelProps> = ({
    title,
    description,
    size = 'large',
    className
}) => {
    const renderDescription = () => {
        if (isString(description)) {
            return <span className="description">{description}</span>;
        } else if (isValidElement(description)) {
            return description;
        } else {
            return null;
        }
    };

    return (
        <div
            className={classNames(
                'fx-prefixed-label',
                { 'size-normal': size === 'normal' },
                className
            )}
        >
            <span className="title">{title}</span>
            {renderDescription()}
        </div>
    );
};

export default PrefixedLabel;
